import { gql } from "graphql-tag";

export const addCategoryMutation = gql`
mutation addCategory(
  $id: Int,
  $name: String,
  $description: String,
  $logoImage: String,
  $bannerImage: String,
  $icon: String,
  $isPopular: Boolean,
  $isJobPhotoRequired: Boolean,
  $travellingPrice: Float,
  $userServiceFeeValue: Float,
  $partnerServiceFeeValue: Float,
  $pricingType: String,
  $status: String,
  $currency: String,
  $slug: String,
  $metaTitle: String,
  $metaDescription: String,
  $displayOrder: Int
) {
addCategory(
  id: $id,
  name: $name,
  description: $description,
  logoImage: $logoImage,
  bannerImage: $bannerImage,
  icon: $icon,
  isPopular: $isPopular,
  isJobPhotoRequired: $isJobPhotoRequired,
  travellingPrice: $travellingPrice,
  userServiceFeeValue: $userServiceFeeValue,
  partnerServiceFeeValue: $partnerServiceFeeValue,
  pricingType: $pricingType,
  status: $status,
  currency: $currency,
  slug: $slug,
  metaTitle: $metaTitle,
  metaDescription: $metaDescription,
  displayOrder: $displayOrder
){
  status
  errorMessage
}
}`;

export const deleteCategoryMutation = gql`
mutation deleteCategory($id: Int) {
  deleteCategory(id: $id) {
    status
    errorMessage
  }
}`;

export const getAllCategoryQuery = gql`
query getAllCategory($currentPage: Int, $searchList: String){
  getAllCategory(currentPage: $currentPage, searchList: $searchList){
   count
    results{
      id
      name
      description
      logoImage
      bannerImage
      isPopular
      isJobPhotoRequired
      travellingPrice
      userServiceFeeValue
      partnerServiceFeeValue
      pricingType
      status
      createdAt
      updatedAt
    }
  }
}`;

// Category Studio (A2): full ordered tree + reorder/duplicate mutations.
export const getCategoryTreeQuery = gql`
query getCategoryTree {
  getCategoryTree {
    status
    count
    errorMessage
    results {
      id
      name
      status
      isPopular
      displayOrder
      pricingType
      currency
      slug
      icon
      logoImage
      categoryIconImageName
      categorylogoImageName
      createdAt
      subCategories {
        id
        name
        status
        categoryId
      }
    }
  }
}`;

// Large Projects catalog (INVERSE of getCategoryTree): same shape, scoped server-side
// to largeProject=true. Aliased to `getCategoryTree` so the shared <CategoryTree>
// component (which reads categoryDetails.getCategoryTree) can be reused as-is.
export const getLargeProjectCategoryTreeQuery = gql`
query getLargeProjectCategoryTree {
  getCategoryTree: getLargeProjectCategoryTree {
    status
    count
    errorMessage
    results {
      id
      name
      status
      isPopular
      displayOrder
      pricingType
      currency
      slug
      icon
      logoImage
      categoryIconImageName
      categorylogoImageName
      createdAt
      subCategories {
        id
        name
        status
        categoryId
      }
    }
  }
}`;

export const reorderCategoriesMutation = gql`
mutation reorderCategories($orderedIds: [Int]) {
  reorderCategories(orderedIds: $orderedIds) {
    status
    errorMessage
  }
}`;

export const reorderSubCategoriesMutation = gql`
mutation reorderSubCategories($categoryId: Int, $orderedIds: [Int]) {
  reorderSubCategories(categoryId: $categoryId, orderedIds: $orderedIds) {
    status
    errorMessage
  }
}`;

export const duplicateCategoryMutation = gql`
mutation duplicateCategory($id: Int) {
  duplicateCategory(id: $id) {
    status
    errorMessage
    result { id name }
  }
}`;

export const updateCategoryStatusMutation = gql`
mutation updateCategoryStatus($id: Int, $fieldName: String, $fieldValue: String) {
  updateCategoryStatus(id: $id, fieldName: $fieldName, fieldValue: $fieldValue) {
    status
    errorMessage
  }
}`;

export const getActiveCategories =  gql`query getActiveCategories {
  getActiveCategories {
    results {
      id
      name
      logoImage
      description
      travellingPrice
      userServiceFeeValue
      partnerServiceFeeValue
    }
    status
    errorMessage
  }
}`;

export const searchCategory = gql`query searchCategory($currentPage: Int, $offset: Int, $loadCount: Int, $searchList: String){
  searchCategory(currentPage: $currentPage, offset: $offset, loadCount: $loadCount, searchList:$searchList) {
    count
    results {
      id
      name
      logoImage
      description
      status
    }
  }
}`
